import { render, staticRenderFns } from "./resultComponent.vue?vue&type=template&id=36acad7c&"
import script from "./resultComponent.vue?vue&type=script&lang=js&"
export * from "./resultComponent.vue?vue&type=script&lang=js&"
import style0 from "./resultComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports